import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AiListeningBrandProfileApiService } from 'src/services/aiListeningApi/brandProfile'

export const useGetAiListeningProfilesQuery = (enabled = true) => {
  return useQuery({
    enabled,
    queryFn: () => AiListeningBrandProfileApiService.getProfiles(),
    queryKey: [QueryKey.GET_AI_LISTENING_PROFILES],
  })
}
